module.exports = __webpack_public_path__ + "img/draw-topbox.1f06aa27.png";